import type { AuthUser } from '../api/types';

const TOKEN_KEY = 'OnlyRead.token';
const USER_KEY = 'OnlyRead.user';
const SESSION_ID_KEY = 'OnlyRead.sessionId';
const PENDING_SELECT_PREFIX = 'OnlyRead.pendingSelect.';

function safeGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* noop */
  }
}

function safeRemove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* noop */
  }
}

export const storage = {
  getToken(): string | null {
    return safeGet(TOKEN_KEY);
  },
  setToken(token: string): void {
    safeSet(TOKEN_KEY, token);
  },
  getUser(): AuthUser | null {
    const raw = safeGet(USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as AuthUser;
    } catch {
      return null;
    }
  },
  setUser(user: AuthUser): void {
    safeSet(USER_KEY, JSON.stringify(user));
  },
  // sessionId — гостевой идентификатор, нужен для /auth/signup. Один раз
  // генерируется, живёт дольше сессии, не очищается при logout.
  getSessionId(): string {
    let id = safeGet(SESSION_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      safeSet(SESSION_ID_KEY, id);
    }
    return id;
  },
  // При upload PDF сервер возвращает список страниц оригинала; нам нужно
  // их показать на странице выбора, но у бэка нет endpoint'a, чтобы получить
  // их позже. Сохраняем число страниц локально, переживает F5.
  setPendingSelectPageCount(fileGUID: string, totalPages: number): void {
    safeSet(PENDING_SELECT_PREFIX + fileGUID, String(totalPages));
  },
  getPendingSelectPageCount(fileGUID: string): number | null {
    const raw = safeGet(PENDING_SELECT_PREFIX + fileGUID);
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : null;
  },
  clearPendingSelectPageCount(fileGUID: string): void {
    safeRemove(PENDING_SELECT_PREFIX + fileGUID);
  },

  clear(): void {
    safeRemove(TOKEN_KEY);
    safeRemove(USER_KEY);
    // sessionId и pendingSelect намеренно не трогаем — они про файлы, не про
    // сессию.
  },
};
